import createApiService from '../../http';
import { FETCH_APP_STATE } from './endpoints';
export const fetchAppStateService = (params) =>
  createApiService({
    endpoint: FETCH_APP_STATE,
    method: "get",
    options: {
      params: {
        ...params,
      },
    },
  });